export default __webpack_public_path__ + "static/media/caleb-connect-icon.b88c9491.svg";